import React from "react";
import Marquee from "react-fast-marquee";

const brands = ["APPLE", "SAMSUNG", "GOPRO", "MICROSOFT", "JBL", "BOSE", "META"];
const dotColors = ["#2f6fd6", "#e0342a", "#f2c010", "#33a852"];

const BrandMarquee = () => {
  return (
    <section id="brand" className="border-y border-white/10 bg-[#050505] py-10" data-testid="marquee-section">
      <Marquee speed={30} gradient={false} autoFill>
        {brands.map((b, i) => (
          <div key={i} className="flex items-center">
            <span className="font-display font-light uppercase tracking-[0.25em] text-4xl md:text-6xl text-white/25 hover:text-white transition-colors duration-300 px-10">
              {b}
            </span>
            <span className="text-3xl md:text-5xl" style={{ color: dotColors[i % dotColors.length] }}>&#8226;</span>
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default BrandMarquee;
